import { render } from "./CallbackView.vue?vue&type=template&id=c4ee3de0"
import script from "./CallbackView.vue?vue&type=script&lang=js"
export * from "./CallbackView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__